import { FilterViewData, FilterViewModel, FilterViewsData } from '@queries'
import { deleteRequest, patchRequest, postRequest } from '../utils'

export interface FilterViewCreatePayload extends Partial<FilterViewData> {
  name: string
  duplicateTapelinesFromFilterViewId?: string
  setActive?: boolean
}

export interface FilterViewModifyPayload extends Partial<FilterViewData> {
  name?: string
}

export const createFilterView: RequestTypeVariable = {
  getKey: (projectGuid: string) => ['createFilterView', projectGuid],
  request: async (projectGuid: string, data: FilterViewCreatePayload): Promise<FilterViewsData> => {
    const { data: result } = await postRequest<FilterViewsData>({
      url: `/projects/${projectGuid}/filter-views`,
      data,
    })
    if (!result) {
      throw new Error('Empty filter views response')
    }
    return result
  },
}

export const updateFilterView: RequestTypeVariable = {
  getKey: (projectGuid: string, filterViewId: string) => [
    'updateFilterView',
    projectGuid,
    filterViewId,
  ],
  request: async (
    projectGuid: string,
    filterViewId: string,
    data: FilterViewModifyPayload,
  ): Promise<FilterViewsData> => {
    const { data: result } = await patchRequest<FilterViewsData>({
      url: `/projects/${projectGuid}/filter-views/${filterViewId}`,
      data,
    })
    if (!result) {
      throw new Error('Empty filter views response')
    }
    return result
  },
}

export const deleteFilterView: RequestTypeVariable = {
  getKey: (projectGuid: string, filterViewId: string) => [
    'deleteFilterView',
    projectGuid,
    filterViewId,
  ],
  request: async (projectGuid: string, filterViewId: string): Promise<FilterViewsData> => {
    const { data: result } = await deleteRequest<FilterViewsData>({
      url: `/projects/${projectGuid}/filter-views/${filterViewId}`,
    })
    if (!result) {
      throw new Error('Empty filter views response')
    }
    return result
  },
}

export const setActiveFilterView: RequestTypeVariable = {
  getKey: (projectGuid: string) => ['setActiveFilterView', projectGuid],
  request: async (projectGuid: string, activeFilterViewId: string): Promise<FilterViewsData> => {
    const { data: result } = await patchRequest<FilterViewsData>({
      url: `/projects/${projectGuid}/active-filter-view`,
      data: { activeFilterViewId },
    })
    if (!result) {
      throw new Error('Empty filter views response')
    }
    return result
  },
}

export type { FilterViewModel }
